import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import singleTripeBottomToggleClassNames from "@/utils/single-trip-amt-toggle-bottom-classnames.utils";

import styles from "./single-trip-amt-toggle-bottom.module.css";

type SingleTripAMTToggleBottomProps = {
  onClick?: () => void;
  singleTripLeftTitle: string;
  singleTripRightTitle: string;
  singleTripRightDescription: string;
  singleTripRightCtaLabel: string;
  isDisabled?: boolean;
};

function SingleTripAMTToggleBottom({
  onClick,
  singleTripLeftTitle,
  singleTripRightTitle,
  singleTripRightDescription,
  singleTripRightCtaLabel,
  isDisabled = false,
}: Readonly<SingleTripAMTToggleBottomProps>) {
  const handleOnClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return (
    <>
      {/* main container */}
      <div
        className="lg:max-w-[1200px] justify-between item-center rounded-radius-xxl bg-surface-neutral-option-1
                  md:max-w-[672px] md:gap-0 md:flex-row md:pb-0
                  flex relative flex-col max-w-full pt-0 pr-0 pb-spacing-l pl-0 gap-spacing-s w-full"
        data-testid="single-trip-toggle-testid"
      >
        {/* left side */}
        <div
          className={`flex justify-center lg:max-w-[50%]  items-center lg:gap-spacing-xs rounded-radius-xxl lg:pt-0 lg:pr-spacing-l lg:pb-0 lg:pl-spacing-l bg-dark-surface-accent-1-primary lg:self-stretch
                    md:flex-col md:max-w-[57.44%]  md:shrink md:self-stretch md:pt-0 md:pb-0 ${singleTripeBottomToggleClassNames.leftSideClassName} ${styles.leftContentPadding} md:gap-0
                    max-w-full  pt-spacing-l pr-spacing-m pb-spacing-l pl-spacing-m gap-spacing-xs w-full`}
        >
          <h2
            className="lg:max-w-[509.42px] lg:min-h-[90px] font-header-font lg:text-[39px] text-center lg:leading-[44.85px] text-surface-neutral-option-1 lg:pt-0
                    md:min-h-[180px] md:text-[39px] md:leading-[44.85px] md:px-0
                     text-[26px] leading-[29.9px] not-italic sm:w-full"
          >
            {singleTripLeftTitle}
          </h2>
        </div>
        {/* right side */}
        <div
          className="lg:max-w-[50%] lg:min-h-[232px] lg:rounded-radius-xxl
                    md:p-spacing-xl md:max-w-[42.56%] md:min-h-[276px] md:rounded-radius-xxl md:px-spacing-xl md:py-spacing-xl md:flex-1
                    flex flex-col justify-center items-center max-w-full min-h-[189px]  pt-spacing-l pr-spacing-l pb-0 pl-spacing-l gap-spacing-xs w-full"
          data-testid="single-trip-right-side-testid"
        >
          <div
            className="lg:max-w-[536px] 
                      md:max-w-[222px]  md:self-stretch md:gap-spacing-s 
                      flex flex-col justify-center items-center h-auto gap-spacing-s self-stretch bg-surface-neutral-option-1 w-full"
          >
            <h3
              className="lg:max-w-[536px] lg:min-h-[72px] lg:text-[31px] lg:font-font-semibold-large lg:leading-[35.65px] lg:pl-[5px] lg:px-[30px]
                      md:max-w-[222px] md:min-h-[116px] md:text-[25px] md:leading-[28.75px] md:px-2
                      max-w-[232px] text-[20px] leading-[23px] h-fit font-font-semibold not-italic font-sub-section-header-font text-center text-text-title w-full"
            >
              {singleTripRightTitle}
            </h3>
            <div
              className="md:max-w-[420.66px]
                        min-w-[100px] min-h-[24px] text-center font-body-font text-[16px] font-normal leading-[24px] text-text-body w-full"
            >
              {singleTripRightDescription}
            </div>
            <LabelButtonWrapper
              data-testid="single-trip-toggle-bottom-cta"
              id="single-trip-toggle-bottom-cta"
              label={singleTripRightCtaLabel}
              hierarchy="primary"
              className={`px-spacing-m text-center font-semibold-font font-semibold md:leading-[20px] text-text-on-primary h-size-xl
                        leading-[18px] text-[18px] ${styles.ctaButton} ${styles.removeLeftIcon} relative disabled:cursor-not-allowed`}
              onClick={handleOnClick}
              isLeftIcon={false}
              isDisabled={isDisabled}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default SingleTripAMTToggleBottom;
